type CookieOptions = {
  days?: number
  domain?: string
  path?: string
  secure?: boolean
  sameSite?: "Lax" | "Strict" | "None" | ""
}

const environment = import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT
const DOMAIN = (() => {
  switch (environment) {
    case "dev":
      return ".dev.suraasa.com"
    case "prod":
      return ".suraasa.com"
    default:
      throw new Error(`Unknown environment: ${environment}`)
  }
})()

const transformNameByEnvironment = (name: string): string => {
  switch (environment) {
    case "dev":
      return `dev_${name}`
    case "prod":
      return name
    default:
      throw new Error(`Unknown environment: ${environment}`)
  }
}

class _CookieHelper {
  constructor() {
    console.log(`CookieHelper initialized for environment: ${environment}`)
  }
  /**
   * Set a cookie
   * @param name - cookie name
   * @param value - cookie value
   * @param options - cookie options
   */
  set(name: CookieKeys, value: string, options: CookieOptions = {}): void {
    console.log(`Setting cookie: ${name}=${value}`)
    const keyName = transformNameByEnvironment(name)

    const {
      days = 1,
      domain = DOMAIN,
      path = "/",
      secure = true,
      sameSite = "None",
    } = options

    let cookie = `${keyName}=${encodeURIComponent(
      value
    )}; path=${path}; domain=${domain};`

    if (secure) cookie += " Secure;"
    if (sameSite) cookie += ` SameSite=${sameSite};`

    document.cookie = cookie
  }

  /**
   * Get a cookie value by name
   * @param name - cookie name
   * @returns cookie value or null if not found
   */
  get(name: string): string | null {
    console.log(`Getting cookie: ${name}`)
    const keyName = transformNameByEnvironment(name)
    const match = document.cookie.match(
      new RegExp("(^| )" + keyName + "=([^;]+)")
    )
    return match ? decodeURIComponent(match[2]) : null
  }

  /**
   * Remove a cookie by name
   * @param name - cookie name
   * @param options - cookie options to match domain/path
   */
  remove(name: string, options: Partial<CookieOptions> = {}): void {
    console.log(`Removing cookie: ${name}`)
    const keyName = transformNameByEnvironment(name)
    const { domain = DOMAIN, path = "/" } = options

    document.cookie = `${keyName}=; path=${path}; domain=${domain};`
  }
}

const CookieHelper = new _CookieHelper()
// @ts-expect-error this is useful for debugging
window.CookieHelper = CookieHelper
export default CookieHelper

export enum CookieKeys {
  studentAuth = "suraasa_student_auth",
}
